export default "/images/vendor/flag-icons/flags/4x3/gm.svg?6e4caca46e637e40175f81818f07cd88";